import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import ChevronXSIcon from "../../../../icons/chevron-xs.icon";
import styles from "./distributor-dropdown.module.scss";

const DISTRIBUTOR_OPTIONS = [
  { id: "highground", name: "HighGround", icon: null },
  { id: "portland", name: "Portland", icon: null },
  { id: "brigantia", name: "Brigantia", icon: null },
  { id: "virosafe", name: "Virosafe", icon: null },
];

const DistributorIcon = ({ name, className }) => {
  const initial = name ? name.charAt(0).toUpperCase() : "?";
  return (
    <div className={className}>
      <span className={styles.iconInitial}>{initial}</span>
    </div>
  );
};

export const DistributorDropdown = ({ value = "Portland", onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDistributor, setSelectedDistributor] = useState(value);

  const handleToggle = (nextShow) => setIsOpen(nextShow);

  const handleSelect = (distributor) => {
    setSelectedDistributor(distributor.name);
    setIsOpen(false);
    if (onChange) {
      onChange(distributor.name);
    }
  };

  const handleKeyDown = (event, distributor) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleSelect(distributor);
    }
  };

  return (
    <Dropdown
      align="start"
      className={styles.dropdown}
      onToggle={handleToggle}
    >
      <Dropdown.Toggle
        className={`${styles.toggle} ${isOpen ? styles.toggleOpen : ""}`}
        variant="link"
      >
        <div className={styles.toggleContent}>
          <div className={styles.toggleIcon}>
            <DistributorIcon name={selectedDistributor} className={styles.iconWrapper} />
          </div>
          <span className={styles.toggleText}>{selectedDistributor}</span>
          {isOpen && (
            <div className={styles.toggleChevron}>
              <ChevronXSIcon className={styles.chevronIcon} />
            </div>
          )}
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu className={styles.menuWrapper}>
        <div className={styles.menu}>
          <div className={styles.menuHeader}>
            <span className={styles.menuHeaderLabel}>Distributors</span>
          </div>

          {DISTRIBUTOR_OPTIONS.map((distributor) => {
            const isSelected = distributor.name === selectedDistributor;
            return (
              <button
                key={distributor.id}
                type="button"
                className={styles.menuItem}
                onClick={() => handleSelect(distributor)}
                onKeyDown={(e) => handleKeyDown(e, distributor)}
                role="option"
                aria-selected={isSelected}
                tabIndex={0}
              >
                <div className={styles.menuItemContent}>
                  <div className={styles.menuItemIcon}>
                    <DistributorIcon name={distributor.name} className={styles.iconWrapper} />
                  </div>
                  <span className={styles.menuItemLabel}>{distributor.name}</span>
                </div>
              </button>
            );
          })}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};
